<template>
    <div>
        <content-view v-show="$utils.renderWhen(this,'productDetail') || $utils.renderWhen(this,'cashierProductDetail')">
            <div class="productDetail">
                <a-form :form="form">
                    <a-form-item label="商品所在仓库：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        <a-input
                            disabled
                            v-model="product.storeageName"
                        />
                    </a-form-item>
                    <a-form-item label="商品名称：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        <a-input
                            disabled
                            v-model="product.name"
                        />
                    </a-form-item>
                    <a-form-item label="商品编号：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        <a-input
                            disabled
                            v-model="product.serialNum"
                        />
                    </a-form-item>
                    <a-form-item label="商品规格：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        <a-input
                            disabled
                            v-model="product.specifica"
                        />
                    </a-form-item>
                    <a-form-item label="商品类别：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        <a-input
                            disabled
                            v-model="product.typeName"
                        />
                    </a-form-item>
                    <a-form-item label="商品单位：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        <a-input
                            disabled
                            v-model="product.unit"
                        />
                    </a-form-item>
                    <a-form-item label="当前库存数/个：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        <a-input-number disabled :min="1" v-model="product.currentInventory"/>
                    </a-form-item>
                    <a-form-item label="商品总入库数/个：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        <a-input-number disabled :min="1" v-model="product.totalInventory"/>
                    </a-form-item>
                    <a-form-item label="商品总销售数/个：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        <a-input-number disabled :min="1" v-model="product.totalSales"/>
                    </a-form-item>
                    <a-form-item label="商品成本价/元：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        <a-input-number disabled :min="1" v-model="product.costPrice"/>
                    </a-form-item>
                    <a-form-item label="商品售卖价/元：" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
                        <a-input-number disabled :min="1" v-model="product.sellPrice"/>
                    </a-form-item>
                    <a-form-item class="text-center">
                        <a-button type="primary" @click="$router.push({name: 'tradeRecordDetail',query: {name: product.name, storagName: product.storeageName, goodsId: product.id, storeId: $route.params.storeageId}})">查看商品出入库记录</a-button>
                    </a-form-item>
                </a-form>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'productDetail',
        components: {},
        props: {},
        data() {
            return {
                form: this.$form.createForm(this),
                id: this.$route.params.id,
                product: {}
            };
        },
        computed: {},
        methods: {
            //商品详情
            productDetail(params) {
                this.$api.storage
                    .productDetail({ params: { id: this.id } })
                    .then(res => {
                        this.product = res;
                    });
            }
        },
        created() {},
        mounted() {
            this.productDetail();
        }
    };
</script>
<style lang="scss">
    .productDetail {
        background-color: #fff;
        padding: 24px 32px;
        border-radius: 2px;
    }
</style>